// Google Play URL helper + campaign attribution, the Android twin of
// appStore.ts.
//
// Play Console attributes installs by the `referrer` param's utm_campaign
// (Acquisition reports -> Traffic sources), so each placement passes its own
// campaign, snake_case with a `web_` prefix, as the App Store `ct` tokens do.
// The package is androidApp.ts's constant, so the listing, the TWA referrer
// check and the intents can never name different apps.

import { ANDROID_APP_PACKAGE } from './androidApp'

export const ANDROID_PLAY_PACKAGE = ANDROID_APP_PACKAGE

/** Google Play listing URL, optionally tagged with a utm_campaign referrer. */
export function playStoreUrl(campaign?: string): string {
  // eslint-disable-next-line i18next/no-literal-string -- Play URL
  const base = `https://play.google.com/store/apps/details?id=${ANDROID_PLAY_PACKAGE}`
  if (!campaign) return base
  // eslint-disable-next-line i18next/no-literal-string -- utm params
  const referrer = `utm_source=commanderbracket.app&utm_medium=web&utm_campaign=${campaign}`
  // eslint-disable-next-line i18next/no-literal-string -- URL param name
  return `${base}&referrer=${encodeURIComponent(referrer)}`
}
